import colors from 'theme/Colors';

// Boolean vairable to control wheather screen title should be shown or not
export const displayScreenTitle: boolean = false;

// landing page title
export const landingPageTitle = '1IDP';

// toast durartion
export const toastDuration = 4;

// default timeing for debounce (in ms)
export const debounceTimeout = 500;

// OTP length
export const defaultOTPlength = 6;

// default user image
export const defaultUserProfile = 'https://picsum.photos/seed/picsum/200/300';
export const mobileViewportWidth = 640;

export const maxPasswordResetAttempts = 3;

export const resetOTPTimer = 45;

export const defaultProjectPercentage = 25;
// default array of months
export const months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

// default array of year from 1975 to 2074
export const years = Array.from({length: 100}, (_, i) =>
  (new Date().getFullYear() - 50 + i).toString(),
);

export const sortOptions = {
  asc: 'Ascending',
  desc: 'Descending',
  latest: 'Latest First',
  oldest: 'Oldest First',
} as const;

// default value for screens
export const staticDataForScreen: staticDataForScreenType = {
  landing_screen: {
    actions: [
      {
        id: 1,
        imageUri: require('../assets/images/AI_action/dashboard.png'),
        title: 'Dashboard of\nPossibilities',
        description:
          'Your daily productivity companion—our AI delivers insights, tracks progress and offers tailored strategies to elevate your work.',
      },
      {
        id: 2,
        imageUri: require('../assets/images/AI_action/search.png'),
        title: 'Search beyond\nlimits',
        description:
          'AI-powered instant discovery that understands your needs—find code, tools, and solutions faster than ever.',
      },
      {
        id: 3,
        imageUri: require('../assets/images/AI_action/knowledge.png'),
        title: 'The living\nknowledge hub',
        description:
          'A dynamic reservoir of expertise—our intelligent system keeps documentation fresh, adapts to your needs, and empowers your learning journey',
      },
      {
        id: 4,
        imageUri: require('../assets/images/AI_action/project.png'),
        title: 'Project command\ncenter',
        description:
          'Master your projects with precision—challenges are foreseen, timelines optimized, and workflows streamlined for maximum efficiency',
      },
      {
        id: 5,
        imageUri: require('../assets/images/AI_action/service.png'),
        title: 'Self-Service\nSuperpowers',
        description:
          'Seamless control at your fingertips—effortlessly deploy, troubleshoot, and monitor while routine tasks handle themselves in the background',
      },
      {
        id: 6,
        imageUri: require('../assets/images/AI_action/collaboration.png'),
        title: 'Collaboration\nElevated',
        description:
          'Where ideas meet action—AI connects teams, highlights opportunities, and amplifies creativity.',
      },
      {
        id: 7,
        imageUri: require('../assets/images/AI_action/roles.png'),
        title: 'Intelligent Role\nBased Access ',
        description:
          'Security meets simplicity— permissions are adjusted dynamically, combining robust security with effortless usability.',
      },
      {
        id: 8,
        imageUri: require('../assets/images/AI_action/catalog.png'),
        title: 'Service Catalog\nfor Innovation',
        description:
          'Streamline your development with AI-driven maintenance, a library of reusable components, and secure API integrations—all in one place.',
      },
    ],
    faqItems: [
      {
        id: 1,
        title: 'How does 1IDP make developers more efficient',
        description:
          '1IDP isn’t just about organizing tools—it’s designed to amplify productivity. By automating repetitive tasks, providing real-time analytics, and offering AI-powered insights, 1IDP empowers developers to focus on what truly matters: writing code, solving problems, and innovating faster.',
      },
      {
        id: 2,
        title: 'Can 1IDP evolve as my organization grows?',
        description:
          'Absolutely! 1IDP was built with scalability in mind. As your team and projects expand, 1IDP’s flexible framework and centralized platform grow with you, adapting to new workflows, additional users, and ever-changing project requirements. It’s not just built for today; it’s built for tomorrow. ',
      },
      {
        id: 3,
        title: 'What makes 1IDP different from other development platforms?',
        description:
          'While other platforms may focus on specific tools or features, 1IDP brings everything together—AI-powered insights, project management, team collaboration, and a unified service catalog—all in one intuitive platform. It’s the synergy of these features that sets 1IDP apart, driving productivity and innovation like no other platform. ',
      },
      {
        id: 4,
        title: 'Can 1IDP help improve cross-team collaboration?',
        description:
          '1IDP is built for collaboration at scale. With features like shared knowledge hubs, real-time communication channels, and integrated project management, teams can seamlessly work together, even if they’re spread across different locations. Collaboration isn’t just a feature—it’s at the core of 1IDP’s design.',
      },
    ],
    heroSection: {
      // navs data will be used for later when we add them to the landing page
      nav: [
        {label: 'About', id: 1},
        {label: 'Service', id: 2},
        {label: 'Pricing', id: 3},
        {label: 'Support', id: 4},
      ],

      // used for animated circles in the landing page
      circles: [
        {
          color: colors.palette.brandBlue,
          name: 'circle1',
          size: 700,
          blur: 80,
          zIndex: -100,
          opacity: 0.8,
          path: [
            {x: 20, y: 100},
            {x: 40, y: 20},
            {x: 70, y: 70},
            {x: 20, y: 60},
            {x: 35, y: 100},
          ],
        },
        {
          color: colors.palette.brandPink,
          name: 'circle2',
          size: 600,
          blur: 80,
          opacity: 0.8,
          path: [
            {x: 45, y: 100},
            {x: 20, y: 50},
            {x: 30, y: 95},
            {x: 50, y: 15},
            {x: 85, y: 56},
          ],
        },
        {
          color: colors.palette.brandBlue,
          name: 'circle3',
          size: 400,
          blur: 80,
          zIndex: -100,
          opacity: 0.8,
          path: [
            {x: 80, y: 100},
            {x: 60, y: 90},
            {x: 60, y: 20},
            {x: 86, y: 86},
            {x: 45, y: 20},
          ],
        },
        {
          color: colors.palette.brandPink,
          name: 'circle4',
          size: 200,
          blur: 50,
          path: [
            {x: 90, y: 70},
            {x: 80, y: 20},
            {x: 40, y: 30},
            {x: 70, y: 70},
            {x: 20, y: 40},
          ],
        },
      ],
    },
    testimonials: [
      {
        title: '"Why can’t everything just\nstay in one place?"',
        description:
          '“Tools, projects, workflows—they’re\n everywhere. I wish there was one place\nwhere everything fit together instead of\nme patching the puzzle every day.”',
      },
      {
        title: '"Where is that file again?"',
        description:
          '“I spend more time hunting for the right \ndocumentation or that one email thread\nthan actually building something.\nShouldn’t everything I need just be...\nRight there?” ',
        active: true,
      },
      {
        title: '"Why can’t I find my team\nwhen I need them?"',
        description:
          '“We’ve got Slack, email, and a dozen other tools, but when it comes to getting quick answers or aligning priorities, it’s like we’re all speaking different languages.” ',
      },
    ],
    signupModalAnimatedCircles: [
      {
        color: colors.palette.brandBlue,
        name: 'circle1',
        size: 80,
        blur: 40,
        path: [
          {x: 20, y: 30},
          {x: 40, y: 30},
          {x: 80, y: 30},
          {x: 80, y: 50},
        ],
      },
      {
        color: colors.palette.brandPink,
        name: 'circle2',
        size: 125,
        blur: 40,
        path: [
          {x: 45, y: 26},
          {x: 70, y: 36},
          {x: 65, y: 70},
          {x: 57, y: 70},
        ],
      },
      {
        color: colors.palette.brandBlue,
        name: 'circle3',
        size: 140,
        blur: 40,
        path: [
          {x: 70, y: 50},
          {x: 53, y: 75},
          {x: 30, y: 65},
          {x: 25, y: 60},
        ],
      },
      {
        color: colors.palette.brandPink,
        name: 'circle4',
        size: 100,
        blur: 40,
        path: [
          {x: 50, y: 80},
          {x: 25, y: 80},
          {x: 25, y: 20},
          {x: 40, y: 20},
        ],
      },
      {
        color: colors.palette.brandBlue,
        name: 'circle5',
        size: 100,
        blur: 40,
        path: [
          {x: 25, y: 70},
          {x: 15, y: 40},
          {x: 55, y: 20},
          {x: 65, y: 25},
        ],
      },
    ],
    footerLinks: [
      {
        id: 12,
        title: 'Quick Links',
        links: [
          {
            id: 1,
            label: 'Home',
            url: '#',
          },
          {
            id: 2,
            label: 'Services',
            url: '#',
          },
          {
            id: 3,
            label: 'Pricing',
            url: '#',
          },
          {
            id: 4,
            label: 'Support',
            url: '#',
          },
        ],
      },
      {
        id: 15,
        title: 'Legal',
        links: [
          {
            id: 5,
            label: 'Privacy Policy',
            url: '#',
          },
          {
            id: 6,
            label: 'Terms & Service',
            url: '#',
          },
          {
            id: 7,
            label: 'Cookie Policy',
            url: '#',
          },
        ],
      },
      {
        id: 14,
        title: 'Contact Us',
        links: [
          {
            id: 8,
            label: 'Email: hello@1idp.com',
            url: '#',
          },
          // {
          //   label: 'Phone: +1 (123) 456-7890',
          //   url: '#',
          // },
        ],
      },
    ],
  },
};

//dummy employee data
export type Employee = {
  _id: number;
  emp_id?: string;
  org_id?: number;
  is_active: boolean;
  first_name: string;
  last_name?: string;
  email: string;
  personal_email?: string;
  phone_number?: number;
  dob?: Date;
  date_of_joining: Date;
  project?: any[];
};
export const employees: Employee[] = [
  {
    _id: 1,
    emp_id: 'emp123',
    first_name: 'Robin',
    last_name: 'Sharma',
    date_of_joining: new Date(2024, 5, 15),
    is_active: true,
    email: 'robin.sharma123@gmail.com',
  },
  {
    _id: 2,
    emp_id: 'emp124',
    first_name: 'Robin',
    last_name: 'Mehta',
    date_of_joining: new Date(2024, 5, 15),
    is_active: false,
    email: 'robin.mehta@gmail.com',
  },
  {
    _id: 3,
    emp_id: 'emp125',
    first_name: 'Robin',
    last_name: 'Singh',
    date_of_joining: new Date(2024, 5, 15),
    is_active: true,
    email: 'robin.singh@gmail.com',
  },
];

// type definition for staticDataForScreen
type actionCardItem = {
  id: number;
  imageUri: any; // actually it's type is module for ex - require("some_module")
  title: string;
  description: string;
};

type FAQItem = {
  id: number;
  title: string;
  description: string;
};

type HeroMenuItem = {
  label: string;
  id: number;
};

type CircleAnimationItems = {
  color: string;
  name: string;
  size: number;
  blur: number;
  zIndex?: number;
  opacity?: number;
  path: {
    x: number;
    y: number;
  }[]; // path point array
};

type TestimonialProblemStatement = {
  title: string;
  description: string;
  active?: boolean;
};

type staticDataForScreenType = {
  landing_screen: {
    actions: actionCardItem[];
    faqItems: FAQItem[];
    heroSection: {
      nav: HeroMenuItem[];
      circles: CircleAnimationItems[];
    };
    testimonials: TestimonialProblemStatement[];
    signupModalAnimatedCircles: CircleAnimationItems[];
    footerLinks: {
      id: number;
      title: string;
      links: {
        id: number;
        label: string;
        url: string;
      }[];
    }[];
  };
};
